export default {
  modelName: (n = 1) => '',
};
